import type { ReactNode } from "react";
import type { PrepSummary } from "@/services/api/teacher";
import { useTalkT } from "./useTalkT";

export function prepBandLabel(
  summary: PrepSummary | null | undefined,
  t: (key: string, options?: Record<string, unknown>) => string,
): string {
  if (summary?.has_open_prep_request) return t("talk_radar_prep_asked");
  if (summary?.has_prep) {
    return t("talk_radar_prep_count", {
      done: summary.lessons_with_prep,
      total: summary.total_lessons,
    });
  }
  return t("talk_radar_no_prep");
}

export function TalkPrepBand({
  summary,
  children,
}: {
  summary: PrepSummary | null | undefined;
  children?: ReactNode;
}) {
  const t = useTalkT();
  return (
    <span className="talk-prepband mb-2 flex items-center gap-2 flex-wrap text-xs rounded px-2.5 py-1.5">
      <span className="font-medium text-purple-800 dark:text-purple-200">Prep:</span>
      <span>{prepBandLabel(summary, t)}</span>
      {children}
    </span>
  );
}
